/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  HTTPValidationError,
  JobInfo,
  JobResult,
  TriggerReportJobParams,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * List the jobs shown on the Scheduled Jobs page along with their category.
 * @summary List Report Jobs
 */
export const listReportJobs = (signal?: AbortSignal) => {
  return customInstance<JobInfo[]>({
    url: `/api/report/jobs`,
    method: "GET",
    signal,
  });
};

export const getListReportJobsQueryKey = () => {
  return ["api", "report", "jobs"] as const;
};

export const getListReportJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof listReportJobs>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listReportJobs>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListReportJobsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listReportJobs>>> = ({
    signal,
  }) => listReportJobs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReportJobs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListReportJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listReportJobs>>
>;
export type ListReportJobsQueryError = ErrorType<void>;

export function useListReportJobs<
  TData = Awaited<ReturnType<typeof listReportJobs>>,
  TError = ErrorType<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listReportJobs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReportJobs>>,
          TError,
          Awaited<ReturnType<typeof listReportJobs>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListReportJobs<
  TData = Awaited<ReturnType<typeof listReportJobs>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listReportJobs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReportJobs>>,
          TError,
          Awaited<ReturnType<typeof listReportJobs>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListReportJobs<
  TData = Awaited<ReturnType<typeof listReportJobs>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listReportJobs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Report Jobs
 */

export function useListReportJobs<
  TData = Awaited<ReturnType<typeof listReportJobs>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listReportJobs>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListReportJobsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Trigger a specific report job by key (optionally for a specific month for reports).
 * @summary Trigger Report Job
 */
export const triggerReportJob = (
  jobKey:
    | "auto_charge_bulk_invoices"
    | "create_bulk_reorders"
    | "confirm_bulk_reorders"
    | "create_low_stock_draft_orders"
    | "notify_advocates_of_stale_low_stock_drafts"
    | "send_daily_text_reminders"
    | "send_weekly_text_reminders"
    | "send_stale_inventory_notifications"
    | "send_warehouse_reorder_alerts"
    | "send_predicted_supply_discrepancy_notifications"
    | "audit_warehouse_quantities"
    | "send_weekly_wholesale_price_notifications"
    | "send_legrande_bulk_order_report"
    | "delete_old_call_recordings"
    | "cleanup_stuck_calls"
    | "send_practice_reports"
    | "send_operational_report"
    | "create_refill_tasks"
    | "send_outcome_questions"
    | "payout_entities"
    | "generate_imprimis_med_wholesale_invoices"
    | "generate_pine_wholesale_invoices"
    | "generate_imprimis_kit_wholesale_invoices"
    | "generate_pq_wholesale_invoices",
  params?: TriggerReportJobParams,
  signal?: AbortSignal,
) => {
  return customInstance<JobResult>({
    url: `/api/report/jobs/${jobKey}`,
    method: "POST",
    params,
    signal,
  });
};

export const getTriggerReportJobMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerReportJob>>,
    TError,
    {
      jobKey:
        | "auto_charge_bulk_invoices"
        | "create_bulk_reorders"
        | "confirm_bulk_reorders"
        | "create_low_stock_draft_orders"
        | "notify_advocates_of_stale_low_stock_drafts"
        | "send_daily_text_reminders"
        | "send_weekly_text_reminders"
        | "send_stale_inventory_notifications"
        | "send_warehouse_reorder_alerts"
        | "send_predicted_supply_discrepancy_notifications"
        | "audit_warehouse_quantities"
        | "send_weekly_wholesale_price_notifications"
        | "send_legrande_bulk_order_report"
        | "delete_old_call_recordings"
        | "cleanup_stuck_calls"
        | "send_practice_reports"
        | "send_operational_report"
        | "create_refill_tasks"
        | "send_outcome_questions"
        | "payout_entities"
        | "generate_imprimis_med_wholesale_invoices"
        | "generate_pine_wholesale_invoices"
        | "generate_imprimis_kit_wholesale_invoices"
        | "generate_pq_wholesale_invoices";
      params?: TriggerReportJobParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerReportJob>>,
  TError,
  {
    jobKey:
      | "auto_charge_bulk_invoices"
      | "create_bulk_reorders"
      | "confirm_bulk_reorders"
      | "create_low_stock_draft_orders"
      | "notify_advocates_of_stale_low_stock_drafts"
      | "send_daily_text_reminders"
      | "send_weekly_text_reminders"
      | "send_stale_inventory_notifications"
      | "send_warehouse_reorder_alerts"
      | "send_predicted_supply_discrepancy_notifications"
      | "audit_warehouse_quantities"
      | "send_weekly_wholesale_price_notifications"
      | "send_legrande_bulk_order_report"
      | "delete_old_call_recordings"
      | "cleanup_stuck_calls"
      | "send_practice_reports"
      | "send_operational_report"
      | "create_refill_tasks"
      | "send_outcome_questions"
      | "payout_entities"
      | "generate_imprimis_med_wholesale_invoices"
      | "generate_pine_wholesale_invoices"
      | "generate_imprimis_kit_wholesale_invoices"
      | "generate_pq_wholesale_invoices";
    params?: TriggerReportJobParams;
  },
  TContext
> => {
  const mutationKey = ["triggerReportJob"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerReportJob>>,
    {
      jobKey:
        | "auto_charge_bulk_invoices"
        | "create_bulk_reorders"
        | "confirm_bulk_reorders"
        | "create_low_stock_draft_orders"
        | "notify_advocates_of_stale_low_stock_drafts"
        | "send_daily_text_reminders"
        | "send_weekly_text_reminders"
        | "send_stale_inventory_notifications"
        | "send_warehouse_reorder_alerts"
        | "send_predicted_supply_discrepancy_notifications"
        | "audit_warehouse_quantities"
        | "send_weekly_wholesale_price_notifications"
        | "send_legrande_bulk_order_report"
        | "delete_old_call_recordings"
        | "cleanup_stuck_calls"
        | "send_practice_reports"
        | "send_operational_report"
        | "create_refill_tasks"
        | "send_outcome_questions"
        | "payout_entities"
        | "generate_imprimis_med_wholesale_invoices"
        | "generate_pine_wholesale_invoices"
        | "generate_imprimis_kit_wholesale_invoices"
        | "generate_pq_wholesale_invoices";
      params?: TriggerReportJobParams;
    }
  > = (props) => {
    const { jobKey, params } = props ?? {};

    return triggerReportJob(jobKey, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerReportJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerReportJob>>
>;

export type TriggerReportJobMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Trigger Report Job
 */
export const useTriggerReportJob = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggerReportJob>>,
      TError,
      {
        jobKey:
          | "auto_charge_bulk_invoices"
          | "create_bulk_reorders"
          | "confirm_bulk_reorders"
          | "create_low_stock_draft_orders"
          | "notify_advocates_of_stale_low_stock_drafts"
          | "send_daily_text_reminders"
          | "send_weekly_text_reminders"
          | "send_stale_inventory_notifications"
          | "send_warehouse_reorder_alerts"
          | "send_predicted_supply_discrepancy_notifications"
          | "audit_warehouse_quantities"
          | "send_weekly_wholesale_price_notifications"
          | "send_legrande_bulk_order_report"
          | "delete_old_call_recordings"
          | "cleanup_stuck_calls"
          | "send_practice_reports"
          | "send_operational_report"
          | "create_refill_tasks"
          | "send_outcome_questions"
          | "payout_entities"
          | "generate_imprimis_med_wholesale_invoices"
          | "generate_pine_wholesale_invoices"
          | "generate_imprimis_kit_wholesale_invoices"
          | "generate_pq_wholesale_invoices";
        params?: TriggerReportJobParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof triggerReportJob>>,
  TError,
  {
    jobKey:
      | "auto_charge_bulk_invoices"
      | "create_bulk_reorders"
      | "confirm_bulk_reorders"
      | "create_low_stock_draft_orders"
      | "notify_advocates_of_stale_low_stock_drafts"
      | "send_daily_text_reminders"
      | "send_weekly_text_reminders"
      | "send_stale_inventory_notifications"
      | "send_warehouse_reorder_alerts"
      | "send_predicted_supply_discrepancy_notifications"
      | "audit_warehouse_quantities"
      | "send_weekly_wholesale_price_notifications"
      | "send_legrande_bulk_order_report"
      | "delete_old_call_recordings"
      | "cleanup_stuck_calls"
      | "send_practice_reports"
      | "send_operational_report"
      | "create_refill_tasks"
      | "send_outcome_questions"
      | "payout_entities"
      | "generate_imprimis_med_wholesale_invoices"
      | "generate_pine_wholesale_invoices"
      | "generate_imprimis_kit_wholesale_invoices"
      | "generate_pq_wholesale_invoices";
    params?: TriggerReportJobParams;
  },
  TContext
> => {
  const mutationOptions = getTriggerReportJobMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
